export default __webpack_public_path__ + "static/media/none.f523c9be.svg";